// Libs
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Context
import SidebarMenuItemsContext from "contexts/sidebar/MenuItems";

// Constants
import { DEFAULT_MENU_ITEMS, CLAIMS_SUB_MENU } from "constants/menu";
import { PATHS } from "constants/routing";

export default function SidebarMenuItemsProvider({ children }) {
  const sidebarMenuItemsState = useState(DEFAULT_MENU_ITEMS);

  // update claims sub routes based on feature switch
  useEffect(() => {
    const [menuItems, updateMenuItems] = sidebarMenuItemsState;
    const newMenuItems = menuItems.map(item =>
      item.path === PATHS.CLAIMS ? { ...item, CLAIMS_SUB_MENU } : item
    );

    updateMenuItems(newMenuItems);
  }, []);

  return (
    <SidebarMenuItemsContext.Provider value={sidebarMenuItemsState}>
      {children}
    </SidebarMenuItemsContext.Provider>
  );
}

SidebarMenuItemsProvider.propTypes = {
  children: PropTypes.node
};
